import React from "react";
import {Draggable, Droppable} from "react-beautiful-dnd";
import {FileTypes} from "src/helpers";
import {Assets} from "src/utils/assets";
import {uploadFileToS3} from "src/utils/utils";
import {Label} from "../label";
import FileManagementPopup from "../popup/FileManagementPopup/FileManagementPopup";
import SelectFileOptionPopup from "../popup/SelectFileOptionPopup";
import LabelEditPopup from "../popup/LabelEditPopup";

interface IImgWrapperProps {
  index?: number;
  id?: string;
  inputClassName?: string;
  item?: any;
  hadImage?: boolean;
  imgURL?: string;
  className?: string;
  label: string;
  readonly?: boolean;
  fileAccept?: FileTypes;
  onClick?: (e?: any) => void;
  onDoubleClick?: () => void;
  onDelete?: () => void;
  onChange: (value: any, e?: React.ChangeEvent<HTMLInputElement>, file?: any, url?: any, fileList?: any[]) => void;
  isVideo?: boolean;
  isDragAndDrop?: boolean;
  isSelected?: boolean;
  multiple?: boolean;
  isFileDroppable?: boolean;
  isSharedDisplay?: boolean;
  isShared?: boolean;
  onIsSharedChange?: (imageType: string, isShared: boolean) => void;
  isCompare?: boolean;
  onCompare?: (item: any, id: string) => void;
  showEditBtn?: boolean;
  onLabelChange?: (newLabel: string) => void;
}

interface IImgWrapperState {
  isShowSelectFilePopup: boolean;
  isShowFileManagementPopup: boolean;
  isShowLabelEditPopup: boolean;
  isShared: boolean;
}

class ImgWrapper extends React.Component<IImgWrapperProps, IImgWrapperState> {
  constructor(props: any) {
    super(props);
    this.state = {
      isShowSelectFilePopup: false,
      isShowFileManagementPopup: false,
      isShowLabelEditPopup: false,
      isShared: this.props.isShared ?? false,
    };
  }

  componentDidUpdate(prevProps: IImgWrapperProps) {
    if (prevProps.isShared !== this.props.isShared) {
      this.setState({isShared: this.props.isShared ?? false});
    }
  }

  handleImageClick = (event: any) => {
    if (event.detail === 1) this.props.onClick && this.props.onClick();
    if (event.detail === 2) this.props.onDoubleClick && this.props.onDoubleClick();
  };

  handleShowSelectFilePopup = (isShow: boolean) => {
    this.setState({isShowSelectFilePopup: isShow});
  };

  handleShowFileManagementPopup = (isShow: boolean) => {
    this.setState({isShowFileManagementPopup: isShow});
  };

  handleShowLabelEditPopup = (isShow: boolean) => {
    this.setState({isShowLabelEditPopup: isShow});
  };

  overrideEventDefaults = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
  };

  onDrop = async (event: any) => {
    this.overrideEventDefaults(event);

    if (!this.props.isFileDroppable) return;
    if (!event.dataTransfer) return;

    const fileListUpload: any[] = [];

    for await (const file of event.dataTransfer.files) {
      const result = await uploadFileToS3(file);

      file.location = result.location;
      fileListUpload.push(file);
    }

    this.props.onChange(undefined, event, undefined, undefined, fileListUpload);
  };

  handleToggleShare = () => {
    const newIsShared = !this.state.isShared;
    this.setState({isShared: newIsShared});

    // 親コンポーネントに変更を通知
    if (this.props.onIsSharedChange && this.props.item?.name) {
      this.props.onIsSharedChange(this.props.item.name, newIsShared);
    }
  };
  handleCompare = (item: any, id: string) => {
    if (this.props.onCompare) {
      this.props.onCompare && this.props.onCompare(item, id);
    }
  };

  render() {
    const fileExtension = this.props.imgURL?.split(".").pop()!;
    const isVideo = ["mp4", "mov", "ogg", "webm", "avi"].includes(fileExtension);
    const isCompare = this.props.isCompare ?? false;
    const showEditBtn = this.props.showEditBtn ?? false;

    return (
      <>
        <Droppable droppableId={this.props.item?.name ?? "null"}>
          {(provided) => (
            <div
              ref={provided.innerRef}
              onClick={this.handleImageClick}
              className={this.props.className || "col-lg-3 col-4 img-wrapper"}
              onDragEnter={this.overrideEventDefaults}
              onDragLeave={this.overrideEventDefaults}
              onDragOver={this.overrideEventDefaults}
              onDrop={this.onDrop}
              {...provided.droppableProps}
            >
              <figure
                className="image-container"
                style={{background: this.props.imgURL ? "" : `url(${Assets.medicalImage}) center no-repeat`}}
              >
                {this.props.isSelected && <img className="select-box" src={Assets.boxActive} alt="" width={20}/>}
                {this.props.hadImage && !this.props.readonly ? (
                  <div
                    className="delete-btn"
                    onClick={() => {
                      if (this.props.onDelete) {
                        this.props.onDelete();
                      }
                    }}
                  >
                    <img className="close-icon" src={Assets.close} alt=""/>
                  </div>
                ) : undefined}
                {provided.placeholder}
                {this.props.imgURL ? (
                  <Draggable
                    draggableId={this.props.item?.name ?? "null"}
                    index={this.props.index! ?? 0}
                    isDragDisabled={!this.props.isDragAndDrop}
                    disableInteractiveElementBlocking
                  >
                    {(provided) => (
                      <div
                        className="images"
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >
                        {isVideo ? (
                          <video controls>
                            <source src={this.props.imgURL}/>
                          </video>
                        ) : (
                          <img src={this.props.imgURL} alt={this.props.label}/>
                        )}
                      </div>
                    )}
                  </Draggable>
                ) : null}
              </figure>
              {/* TODO */}
              <div className="d-flex justify-content-center">
                <div className="position-relative d-inline-block">
                  <Label
                    className={isCompare ? "btn" : "btn btn-outline-primary"}
                    text={this.props.label}
                    onClick={() => !this.props.readonly && this.handleShowSelectFilePopup(true)}
                  />
                  {showEditBtn && (
                    <button
                      type="button"
                      className="d-flex align-items-center justify-content-center"
                      style={{
                        position: 'absolute',
                        top: '-10px',
                        right: '-12px',
                        borderRadius: '50%',
                        backgroundColor: "#02a3af",
                        width: '24px',
                        height: '24px',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                        zIndex: 10
                      }}
                      onClick={() => !this.props.readonly && this.handleShowLabelEditPopup(true)}
                    >
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="white">
                        <path
                          d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
                      </svg>
                    </button>
                  )}
                </div>
              </div>
              {isCompare && (
                <Label
                  className="btn btn-outline-primary"
                  text="選択"
                  onClick={() => this.handleCompare(this.props.item, this.props.id || "")}
                />
              )}

              {this.props.isSharedDisplay && (
                <div className="d-flex align-items-center justify-content-center mt-2">
                  <span className="ml-2" style={{
                    fontSize: '16px',
                    color: this.state.isShared ? '#6c757d' : '#6c757d'
                  }}>
                  共有
                  </span>
                  <button
                    type="button"
                    className="d-inline-flex align-items-center"
                    style={{
                      cursor: 'pointer',
                      border: 'none',
                      background: 'transparent',
                      position: 'relative'
                    }}
                    onClick={this.props.readonly ? undefined : this.handleToggleShare}
                  >
                    <div style={{
                      width: '48px',
                      height: '24px',
                      backgroundColor: this.state.isShared ? '#02a3af' : '#6c757d',
                      borderRadius: '24px',
                      position: 'relative',
                      transition: 'background-color 0.2s ease-in-out'
                    }}>
                      <div style={{
                        position: 'absolute',
                        top: '2px',
                        left: '2px',
                        width: '20px',
                        height: '20px',
                        backgroundColor: 'white',
                        borderRadius: '50%',
                        boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
                        transform: this.state.isShared ? 'translateX(24px)' : 'translateX(0px)',
                        transition: 'transform 0.2s ease-in-out'
                      }}></div>
                    </div>
                  </button>
                </div>
              )}
            </div>
          )}
        </Droppable>
        {this.state.isShowSelectFilePopup && (
          <SelectFileOptionPopup
            isShow={this.state.isShowSelectFilePopup}
            handleShow={this.handleShowSelectFilePopup}
            handleShowFileManagementPopup={this.handleShowFileManagementPopup}
            id={this.props.id}
            inputClassName={this.props.inputClassName}
            fileAccept={this.props.fileAccept}
            onChange={(_, event, ___, ____, fileList) => {
              this.handleShowSelectFilePopup(false);

              this.props.onChange(undefined, event, undefined, undefined, fileList!);
            }}
            multiple={this.props.multiple}
          />
        )}
        {this.state.isShowFileManagementPopup && (
          <FileManagementPopup
            isShow={this.state.isShowFileManagementPopup}
            handleShow={this.handleShowFileManagementPopup}
            fileAccept={this.props.fileAccept}
            onChange={async (_: any, event: any, ___: any, ____: any, fileList?: any[]) => {
              this.handleShowFileManagementPopup(false);

              const fileListUpload: any[] = [];

              for await (const file of fileList!) {
                file.location = file.url;

                fileListUpload.push(file);
              }

              this.props.onChange && this.props.onChange(undefined, event, undefined, undefined, fileListUpload);
              this.handleShowSelectFilePopup(false);
            }}
            multiple={this.props.multiple}
          />
        )}
        {this.state.isShowLabelEditPopup && (
          <LabelEditPopup
            isShow={this.state.isShowLabelEditPopup}
            handleShow={this.handleShowLabelEditPopup}
            initialLabel={this.props.label}
            onChange={(newLabel: string) => {
              this.props.onLabelChange && this.props.onLabelChange(newLabel);
              this.handleShowLabelEditPopup(false);
            }}
          />
        )}
      </>
    );
  }
}

export default ImgWrapper;
